/**
 * @generated SignedSource<<9b86732df675d988923df2f13d9b7767>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FundsTableHeader_header$data = {
  readonly tableheader: ReadonlyArray<{
    readonly col: string | null | undefined;
    readonly label: string | null | undefined;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "FundsTableHeader_header";
};
export type FundsTableHeader_header$key = {
  readonly " $data"?: FundsTableHeader_header$data;
  readonly " $fragmentSpreads": FragmentRefs<"FundsTableHeader_header">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FundsTableHeader_header",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TableHeader",
      "kind": "LinkedField",
      "name": "tableheader",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "col",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "label",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "FundsTable",
  "abstractKey": null
};

(node as any).hash = "d5966cc9f94319d817d7ec863efba7e5";

export default node;
